export default __webpack_public_path__ + "static/media/CheckUp.c7faafb0.svg";